import { css } from '@emotion/css';

export const screenshotButton = css`
  label: screenshot-button;
  margin-left: -2px;
`;
